import React, { useCallback } from 'react';

import ReplaceSkuWizard from '@components/shared/products/ReplaceSkuWizard';
import ListPageHeader from '@shared/ListPageHeader';
import { useNavigate } from 'react-router-dom';

import { productService } from '@services/admin/productService';

export default function ReplaceSku() {
  const navigate = useNavigate();

  const handleSuccess = useCallback(() => {
    // Optionally navigate back or show success message (Wizard already shows success)
    // navigate('/products');
  }, [navigate]);

  const handleCancel = useCallback(() => {
    navigate('/products');
  }, [navigate]);

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['products', 'products.replace_sku']}
      />
      <ReplaceSkuWizard
        productService={productService}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
}
